// frontend/src/services/utils.js

export const formatCurrency = (value) => {
  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return 'Precio no válido';
  }
  return `${numberValue.toLocaleString('es-PY')} GS`;
};

// Toma un string como "50.000" y devuelve el número 50000
export const parseFormattedNumber = (str) => {
  if (!str || typeof str !== 'string') return 0;
  return Number(str.replace(/\./g, ''));
};

// Toma un número como 50000 y devuelve el string "50.000"
export const formatNumberInput = (num) => {
  if (num === null || num === undefined) return '';
  return num.toLocaleString('es-PY');
};

// URL base para imágenes almacenadas en Cloudflare R2
export const IMAGE_BASE_URL = 'https://pub-61f4c4a90c6141d9867828c3ff6bef19.r2.dev/';
